import { Box } from '@air/zephyr';
import { motion, useSpring, useTransform, useViewportScroll } from 'framer-motion';
import Image from 'next/image';

import { useRefScrollProgress } from '~/hooks/useRefScrollProgress';

export const AdobeSplashHeroTemplateImage = () => {
  const { ref, start, end } = useRefScrollProgress({ offset: -0.1 });
  const { scrollYProgress } = useViewportScroll();

  const layer1YPos = useTransform(scrollYProgress, [start, end], [100, 0]);
  const layer1YPosAnimation = useSpring(layer1YPos, { stiffness: 200, damping: 20 });

  const layer2YPos = useTransform(scrollYProgress, [start, end], [300, 0]);
  const layer2YPosAnimation = useSpring(layer2YPos, { stiffness: 200, damping: 20 });
  const layer2ScaleAnimation = useTransform(scrollYProgress, [start, end], [0.9, 1]);

  const layer3YPos = useTransform(scrollYProgress, [start, end], [200, 0]);
  const layer3YPosAnimation = useSpring(layer3YPos, { stiffness: 200, damping: 20 });

  const easterEggYPos = useTransform(scrollYProgress, [start, end], [200, 0]);
  const easterEggYPosAnimation = useSpring(easterEggYPos, { stiffness: 200, damping: 20 });

  return (
    <Box tx={{ width: '100%', maxWidth: 1160 }} ref={ref}>
      <Box tx={{ zIndex: 1, position: 'relative', pb: '51.2%' }}>
        <Box
          as={motion.div}
          tx={{ position: 'absolute', top: '2%', left: '19.4%', width: '68.4%' }}
          style={{ y: layer1YPosAnimation }}
        >
          <Image height={482.5} src="/assets/marketing/adobe-splash-template-1.png" width={793} />
        </Box>

        <Box
          as={motion.div}
          tx={{ position: 'absolute', top: '51.8%', left: '6.2%', width: '32.9%' }}
          style={{ scale: layer2ScaleAnimation, y: layer2YPosAnimation }}
        >
          <Image height={292} src="/assets/marketing/adobe-splash-template-2.png" width={382.5} />
        </Box>

        <Box
          as={motion.div}
          tx={{ position: 'absolute', top: '64.3%', left: '76.3%', width: '16.75%' }}
          style={{ y: layer3YPosAnimation }}
        >
          <Image height={197} src="/assets/marketing/adobe-splash-template-3.png" width={194.5} />
        </Box>

        <Box
          as={motion.div}
          tx={{ zIndex: -1, position: 'absolute', top: '32.6%', left: '9.5%', width: '17.6%' }}
          style={{ y: layer3YPosAnimation }}
        >
          <Image height={207} src="/assets/marketing/adobe-splash-template-4.svg" width={207} />
        </Box>

        <Box
          as={motion.div}
          tx={{ zIndex: -1, position: 'absolute', top: '56.3%', right: '7.5%', width: '6.1%' }}
          style={{ y: layer3YPosAnimation }}
        >
          <Image height={77} src="/assets/marketing/adobe-splash-template-5.svg" width={82} />
        </Box>

        <Box
          as={motion.div}
          tx={{ zIndex: -1, position: 'absolute', top: '47.6%', right: '5%', width: '1.9%' }}
          style={{ y: layer2YPosAnimation }}
        >
          <Image height={22} src="/assets/marketing/adobe-splash-template-6.svg" width={24} />
        </Box>

        {process.env.NEXT_PUBLIC_VERCEL_ENV !== 'production' && (
          <Box
            as={motion.div}
            tx={{ zIndex: -1, position: 'absolute', top: '-14.5%', right: '20%', width: '30%' }}
            style={{ y: easterEggYPosAnimation }}
          >
            <Image height={128} src="/assets/marketing/shane-watching.png" width={128} />
          </Box>
        )}
      </Box>
    </Box>
  );
};
